/**
 * Respect for `prefers-reduced-motion` — a single source of truth.
 *
 * This query used to be duplicated in every gesture hook (row-swipe, and
 * it would be ported again for the carousel and drag-to-dismiss). Centralized
 * here, all gestures answer "animate or skip?" the same way and a future
 * override (e.g. a custom accessibility setting) is changed in one place. SSR-safe.
 */

// oxlint-disable-next-line lingui/no-unlocalized-strings -- CSS media query, not UI copy
const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

export function prefersReducedMotion(): boolean {
  return globalThis.matchMedia?.(REDUCED_MOTION_QUERY).matches ?? false;
}
